<template>
  <div>
    <va-card class="import-card">
      <h5>{{ title }}</h5>
      <va-progress-bar :value="progress" :color="status_color" />
      <strong v-if="progress > 0 && progress < 100"> {{ `${progress} % Importando ${resource}...`}}</strong>
      <strong v-if="progress == 100"> {{ `${progress} % Import concluído!`}}</strong>
        <div class="va-row row wrap">
          <div class="flex xs3">
            <form ref="form" @submit.prevent>
              <va-file-upload type="single" dropzone v-model="file" />
              <va-button
                color="greenLight"
                icon="iconicstroke iconicstroke-info"
                @click="submitFile()"
                :disabled=buttonDisabled
              >
                {{ $t('menu.save')}}
              </va-button>

              <va-button
                color="gray"
                icon="iconicstroke iconicstroke-trash-stroke"
                @click="reset()"
              >
                {{ $t('menu.clear')}}
              </va-button>
              <BackButton :id="this.$route.params.id"/>
            </form>
          </div>

          <template v-if='csv_xlsx'>
            <div class="flex xs2" align="center">
              <va-card>
                <strong>Modelo de Arquivo .csv</strong>
                <a :href="csv_model" download>
                  <img src="csv.png"/>
                </a>
              </va-card>
            </div>

            <div class="flex xs2" align="center">
              <va-card >
                <strong>Modelo de Arquivo .xlsx</strong>
                <a :href="xlsx_model" download>
                  <img src="excel.png" />
                </a>
              </va-card>
            </div>
          </template>
        </div>
    </va-card>
  </div>
</template>

<script>
import { showError } from '@/global'
import { http } from '@/services/config'
import BackButton from './BackButton.vue'
import Vue from 'vue'
import { mapState } from "vuex"

export default {
  props: ["title", "resource", "csv_xlsx", "import_endpoint", "xlsx_model", "csv_model", "params"],
  components: { BackButton },
  data () {
    return {
      file: [],
      progress: 0,
      status_color: 'greenLight',
      loading: false,
      buttonDisabled: false,
    }
  },

  channels: {
    ImportProgress: {
      received (data) {
        this.progress = data.progress
        this.loading = true
        if (this.progress === 100) {
          this.showToast(this.$t('toast.successfullyDataImported'), {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
          this.$cable.unsubscribe({ channel: 'ImportProgress' })
          this.reset()
        }

        if (Object.prototype.hasOwnProperty.call(data, 'error')) {
          this.status_color = 'red'
          this.showToast(data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
          this.$cable.unsubscribe({ channel: 'ImportProgress' })
          this.reset()
        }
      },
    },
  },

  computed: {
    ...mapState(['currentLocality']),
  },

  methods: {
    reset () {
      this.file = []
      this.progress = 0
      this.loading = false
      this.buttonDisabled = false
      this.status_color = 'greenLight'
      this.$cable.unsubscribe({ channel: 'ImportProgress' })
    },

    async submitFile () {
      this.progress = 0
      this.status_color = 'greenLight'
      this.buttonDisabled = true

      var channel_name = this.file[0].name + Date.now()
      this.$cable.subscribe({ channel: 'ImportProgress', this_import: channel_name })

      let formData = new FormData()
      formData.append('file', this.file[0])
      formData.append('channel', channel_name)
      formData.append('locality_id', this.currentLocality.id)
      if (typeof this.params !== 'undefined') {
        for (var pair of this.params.entries()) {
          formData.append(pair[0], pair[1])
        }
      }

      http.post(this.import_endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
  },
}
</script>

<style scoped>
.import-card {
  min-height: 300px;
  max-height: 400px;
}

.import-card h5 {
  margin-bottom: 50px;
}

form {
  padding-top: 25px;
}

img, svg {
  height: 100px;
}
</style>
